import { Accordion, Center, Loader, Stack, Text } from "@mantine/core";
import AccountCard, { Account } from "./AccountCard"
import { AddCalendarAccountWrapper } from "./AddCalendarAccount";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";
import { useState } from "react";

export const AccountTab = ({
    accounts,
    accountsLoaded,
    accountsRefreshing,
    updateAccounts,
}: {
    accounts: Account[];
    accountsLoaded: boolean;
    accountsRefreshing: boolean;
    updateAccounts: () => void;
}) => {
    const { t } = useTranslation(['app']);
    const { user } = useAuth();

    const queryParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
    const [errorParam, _] = useState(queryParams.get('error'));

    return (
        <>
            {accountsRefreshing &&
                <Center my="sm">
                    <Loader size="sm" />
                </Center>
            }
            {accountsLoaded && accounts.length === 0 &&
                <div className="alert alert-success my-3" role="alert">
                    <Stack gap="4">
                        <span className='fw-bold'> {t("dashboard.welcome")} 🎉 </span>
                        {t("dashboard.first-thing")}
                    </Stack>
                </div>
            }
            {(!accountsLoaded || accounts.length > 0) ?
                <div className='display-5 my-4'>{t("dashboard.connect-account")}</div>
                :
                <div className='display-5 my-4'></div>
            }
            {accountsLoaded && accounts.length === 1 &&
                <div>
                    <div className="alert alert-success" role="alert">
                        <span className='fw-bold'> {t("dashboard.one-account")} ✅ </span><br />
                        {t("dashboard.second-account")}
                    </div>
                </div>
            }
            {errorParam === 'scope-error' &&
                <Center>
                    <Text c='red' mb='sm'>
                        {t('scope_error.short_description')}
                    </Text>
                </Center>
            }
            <AddCalendarAccountWrapper user={user} accounts={accounts} updateAccounts={updateAccounts} />
            {accountsLoaded && accounts.length > 0 &&
                <>
                    <div className='display-5 my-4'>{t("dashboard.connected-accounts")}</div>

                    <Accordion variant='contained'>
                        {accounts.map((account) => (
                            <AccountCard key={account.uuid} account={account} updateAccounts={updateAccounts} />
                        ))}
                    </Accordion>
                </>
            }
            {!accountsLoaded &&
                <Center my="md">
                    <Loader size="sm" />
                </Center>
            }
        </>
    )
}
